'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Input } from '@achra/ui/input';
import { cn } from '@achra/ui/lib/utils';
import { ArrowRight } from 'lucide-react';
import Image from 'next/image';
import { useActionState } from 'react';
import { type HomeWaitlistFormState, submitHomeWaitlistAction } from '@/modules/home/actions/home-waitlist-action';
import { AnimatedSubtitle } from '@/modules/home/components/animated-subtitle';
import { SpotlightGrid } from '@/shared/components/spotlight-grid';
import { useMediaQuery } from '@/shared/hooks/use-media-query';
import { WaitlistIsotype } from './waitlist-isotype';
const initialState: HomeWaitlistFormState = {
  success: false
};
function HomeWaitlistSection() {
  const $ = _c(11);
  const [state, formAction, isPending] = useActionState(submitHomeWaitlistAction, initialState);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      from: "sm"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isSmUp = useMediaQuery(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pointer-events-none absolute inset-0" aria-hidden={true}><Image src="/home/waitlist/bg.png" alt="" fill={true} loading="lazy" className="object-fill object-right-top" /></div>;
    t2 = <SpotlightGrid spotlightRadius={120} gridSize={50} containerSelector="[data-waitlist-card]" highlightOpacity={0.45} showBaseGrid={true} />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <header className="mx-auto max-w-2xl text-center"><h2 id="home-waitlist-heading" className="text-foreground text-3xl font-semibold tracking-tight text-balance sm:text-4xl">Join the Waitlist</h2><AnimatedSubtitle className="text-foreground/80 mt-4 text-base leading-relaxed text-pretty sm:text-lg">Connect your org, empower your network and operate as one.</AnimatedSubtitle></header>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isPending || $[5] !== isSmUp || $[6] !== state.email || $[7] !== state.error || $[8] !== state.message || $[9] !== state.success) {
    t4 = <section id="home-waitlist-section" className="w-full py-16 sm:py-20 lg:py-24" aria-labelledby="home-waitlist-heading"><div className="container"><div data-waitlist-card={true} className="border-border bg-secondary relative overflow-hidden rounded-2xl border">{t1}{t2}<div className="relative z-10 px-5 py-16 sm:px-12 lg:p-16">{t3}<div className="mx-auto mt-10 max-w-xl sm:mt-12">{state.success ? <p className="text-foreground text-center text-base font-medium sm:text-lg" role="status">{state.message}</p> : <form action={formAction} className="w-full"><div className={cn("border-border flex flex-row items-center gap-0 rounded-xl border bg-[#EDEDED] p-1.5 pl-3 sm:pl-4", state.error && "ring-2 ring-red-500/35")}><div className="flex min-w-0 flex-1 items-center gap-2.5 sm:gap-3"><WaitlistIsotype /><Input id="home-waitlist-email" name="email" type="email" autoComplete="email" placeholder={isSmUp ? "Drop your email for launch updates." : "Email"} defaultValue={state.email ?? ""} aria-invalid={!!state.error} aria-describedby={state.error ? "home-waitlist-error" : undefined} disabled={isPending} required={true} className={cn("text-foreground h-11 min-w-0 flex-1 border-0 bg-transparent px-0 text-[15px] shadow-none", "placeholder:text-foreground/60 focus-visible:ring-0 md:text-base")} /></div><Button type="submit" disabled={isPending} className="bg-primary hover:bg-primary/92 inline-flex size-11 shrink-0 items-center justify-center rounded-lg border-0 text-sm font-semibold text-white sm:ml-1 sm:h-11 sm:w-auto sm:px-6"><span className="hidden sm:inline">{isPending ? "Sending\u2026" : "Get Notified"}</span><ArrowRight className="size-4 sm:ml-1.5" strokeWidth={2.25} aria-hidden={true} /></Button></div>{state.error ? <p id="home-waitlist-error" className="mt-3 text-center text-sm text-red-600" role="alert">{state.error}</p> : null}</form>}</div></div></div></div></section>;
    $[4] = isPending;
    $[5] = isSmUp;
    $[6] = state.email;
    $[7] = state.error;
    $[8] = state.message;
    $[9] = state.success;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export { HomeWaitlistSection };